var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-header flex"},[_c('div',{staticClass:"flex1",on:{"mouseenter":_vm.enter,"mouseleave":_vm.leave}},[_vm._t("HeaderLeft")],2),_c('div',{staticClass:"img flexs"},[_vm._v("智 慧 交 通 数 据 驾 驶 舱")]),_c('div',{staticClass:"flex1"},[_vm._t("HeaderRight")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }